import { createFileRoute } from "@tanstack/react-router";
import Privacy from "@/pages/Privacy";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/privacy")({
  head: () => pageHead("/privacy", "th"),
  component: Privacy,
});
